<script lang="ts">
import type { ValueOf } from '../../types/helper';

const colors = {
  grey: 'grey',
  white: 'white',
} as const;

type Props = { color?: ValueOf<typeof colors> };
</script>

<script setup lang="ts">
withDefaults(defineProps<Props>(), {
  color: 'grey',
});
</script>

<template>
  <div :class="[$style.container, $style[`color-${colors[color]}`]]" />
</template>

<style module lang="scss" src="./Divider.scss" />
